package com.sddamico.swigmore

import com.sddamico.swigmore.ds.SwColor
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/** Silk's page palette, pinned to the design's green field + cream ink in both color modes. */
@InitSilk
fun initTheme(ctx: InitSilkContext) {
  ctx.theme.palettes.dark.background = SwColor.fieldColor
  ctx.theme.palettes.dark.color = SwColor.creamColor
  ctx.theme.palettes.light.background = SwColor.fieldColor
  ctx.theme.palettes.light.color = SwColor.creamColor
}
